
export const categoryActions = self => ({
  update(c) {
    self.set('title', c.title)
    self.set('description', c.description)
    self.set('icon', c.icon)
    self.set('itemCount', c.itemCount)
  },
  set(key, value) {
    self[key] = value
  }
})